import { TextInput } from "@/components/shared/FormInputs";
import { PhoneInput } from "@/components/ui/phone-input";
import type { WaitlistFormFieldErrors } from "@/types/waitlist";
import { cn } from "@paribus/shared-ui";
import type { Value } from "react-phone-number-input";

interface WaitlistStepContactProps {
  visible: boolean;
  name: string;
  email: string;
  organizationName: string;
  contactPhone: string;
  isSubmitting: boolean;
  errors: WaitlistFormFieldErrors;
  onNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onOrganizationNameChange: (value: string) => void;
  onContactPhoneChange: (value: string) => void;
}

export const WaitlistStepContact = ({
  visible,
  name,
  email,
  organizationName,
  contactPhone,
  isSubmitting,
  errors,
  onNameChange,
  onEmailChange,
  onOrganizationNameChange,
  onContactPhoneChange,
}: WaitlistStepContactProps) => (
  <div
    className={cn(
      "transition-all duration-300",
      visible ? "block animate-in fade-in slide-in-from-right-4" : "hidden"
    )}
  >
    <TextInput
      label="Name"
      value={name}
      placeholder="Your full name"
      onChange={onNameChange}
      autoComplete="name"
      error={errors.name}
    />
    <TextInput
      type="email"
      label="Email Address"
      value={email}
      placeholder="Enter your email"
      onChange={onEmailChange}
      autoComplete="email"
      error={errors.email}
    />
    <TextInput
      label="Organization Name"
      value={organizationName}
      placeholder="Your organization"
      onChange={onOrganizationNameChange}
      autoComplete="organization"
      error={errors.organizationName}
    />

    <div className="mb-5">
      <label
        htmlFor="waitlist-phone"
        className="mb-2 block text-sm font-semibold text-muted-foreground"
      >
        Phone number
        <span className="ml-1 text-destructive">*</span>
      </label>
      <div
        className={cn(
          "flex overflow-hidden rounded-lg border bg-surface-subtle focus-within:shadow-focus",
          errors.contactPhone ? "border-destructive" : "border-input"
        )}
      >
        <PhoneInput
          id="waitlist-phone"
          international
          defaultCountry="US"
          placeholder="Enter a phone number"
          value={contactPhone || undefined}
          onChange={(v: Value) => onContactPhoneChange(String(v ?? ""))}
          disabled={isSubmitting}
          className="w-full"
        />
      </div>
      {errors.contactPhone && (
        <p className="mt-1 text-sm text-destructive-text">{errors.contactPhone}</p>
      )}
    </div>
  </div>
);
